'use client';
import { RootState } from '@/redux/store';
import { FloatingWhatsApp, RenderWhenIdle } from '@repo/ui';
import { useSelector } from 'react-redux';

const Chatbot = () => {
  const isAuth = useSelector((state: RootState) => state.userdata.isAuth);
  // Mounted once the browser is idle: keeps the chat button out of hydration
  return (
    <RenderWhenIdle>
      <FloatingWhatsApp enable={!!isAuth} />
    </RenderWhenIdle>
  );
};

export default Chatbot;
